import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { MatSnackBar } from '@angular/material/snack-bar';

// Translate
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { locale as spanish } from './i18n/es';

// Model
import { User } from '../../../models/users.model';
import { UsuariosService } from 'app/main/usuarios/usuarios.service';

@Component({
    selector: 'app-usuarios-add',
    templateUrl: './usuarios-add.component.html',
    styleUrls: ['./usuarios-add.component.scss'],
    providers: [UsuariosService]
})
export class UsuariosAddComponent implements OnInit, OnDestroy
{
    public form: FormGroup;
    public user: User;
    public statusUser: string;

    // Private
    private _unsubscribeAll: Subject<any>;

    /**
     * Constructor
     *
     * @param _formBuilder
     * @param _fuseTranslationLoaderService
     * @param _route
     * @param _router
     * @param _usuariosService
     * @param _location
     * @param _matSnackBar
     */
    constructor(
        private _formBuilder: FormBuilder,
        private _fuseTranslationLoaderService: FuseTranslationLoaderService,
        private _route: ActivatedRoute,
        private _router: Router,
        private _usuariosService: UsuariosService,
        private _location: Location,
        private _matSnackBar: MatSnackBar
    )
    {
        // Set the private defaults
        this._fuseTranslationLoaderService.loadTranslations(spanish);
        this._unsubscribeAll = new Subject();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------


    /**
     * On init
     */
    ngOnInit(): void {
        this.user = new User();
        // Reactive Form
        this.form = this.createProductForm();
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }


    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Create product form
     *
     * @returns {FormGroup}
     */
    createProductForm(): FormGroup
    {
        return this._formBuilder.group({
            id              : [this.user.id],
            name            : [this.user.name, [Validators.required]],
            role            : [this.user.role, [Validators.required]],
            email           : [this.user.email, [Validators.required, Validators.email]],
            password        : [this.user.password, [Validators.required, Validators.maxLength(20)]],
            active          : [this.user.active]
        });

    }

    saveUser(): void {
        this._usuariosService.create(this.form.value)
            .then(() => {
                    this._matSnackBar.open('Usuario agregado', 'OK', {
                        verticalPosition: 'top',
                        duration        : 2000
                    });

                    this._router.navigate(['/usuarios']);
            })
            .catch((error: any) => {
                this._matSnackBar.open('Error en actualización', 'Error', {
                    verticalPosition: 'top',
                    duration        : 2000
                });
            });
    }
}
